// extracted by mini-css-extract-plugin
export default {"lottery":"index_lottery_rOv9G"};